var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 4.344H5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h14a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5Zm-14-1.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-11a2 2 0 0 0-2-2H5Zm6.934 3.826c0-.385.313-.697.698-.697h3.21a.697.697 0 0 1 .472 1.21L8.386 14.49a.697.697 0 0 1-.945-1.026l6.615-6.098h-1.424a.697.697 0 0 1-.698-.697Zm.845 5.374c.385-.005.701.304.706.689l.014 1.278a.697.697 0 0 1-1.395.016l-.014-1.278a.697.697 0 0 1 .69-.705Zm4.003-2.16a.697.697 0 1 0-1.395 0v4.135a.697.697 0 0 0 1.395 0V9.884ZM6 19.656a.75.75 0 0 0 0 1.5h12a.75.75 0 1 0 0-1.5H6Z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-follow-fill": "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/门店经营.fe10d9fbb718ebac3dd1a2d5693c81bb.svg";
export { ForwardRef as ReactComponent };